// extracted by mini-css-extract-plugin
export var header = "_em-0";